import React from "react";

const pageReloadKey = "page-has-been-force-refreshed";
/**
 * 
 * @param {() => Promise<{ default: React.ComponentType<any> }>} componentImport 
 * @returns 
 */
export default function lazy(componentImport) {
    return React.lazy(async () => {
        const pageHasAlreadyBeenForceRefreshed = window.localStorage.getItem(pageReloadKey) || "false";

        try {
            const component = await componentImport();

            window.localStorage.setItem(pageReloadKey, "false");

            return component;
        } catch (error) {
            if (pageHasAlreadyBeenForceRefreshed === "false") {
                // Assuming that the user is not on the latest version of the application.
                // Let's refresh the page immediately.
                window.localStorage.setItem(pageReloadKey, "true");
                return window.location.reload(true);
            }

            // The page has already been reloaded
            // Assuming that user is already using the latest version of the application.
            // Let's let the application crash and raise the error.
            throw error;
        }
    });
}
